var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1001 17.0502L35.7001 6.97521C31.7751 4.22521 25.7501 4.37521 21.9751 7.30021L9.4501 17.0752C6.9501 19.0252 4.9751 23.0252 4.9751 26.1752V43.4252C4.9751 49.8002 10.1501 55.0002 16.5251 55.0002H43.4751C49.8501 55.0002 55.0251 49.8252 55.0251 43.4502V26.5002C55.0251 23.1252 52.8501 18.9752 50.1001 17.0502ZM31.8751 45.0002C31.8751 46.0252 31.0251 46.8752 30.0001 46.8752C28.9751 46.8752 28.1251 46.0252 28.1251 45.0002V37.5002C28.1251 36.4752 28.9751 35.6252 30.0001 35.6252C31.0251 35.6252 31.8751 36.4752 31.8751 37.5002V45.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6addd3ca9d1116a0ad43b40443b4a695.svg";
export { ForwardRef as ReactComponent };